import React from 'react';
import GameQuery from '../../query/GameQuery';
import ProcurementSupplier from '../../components/ProcurementSupplier';
import { Route } from 'react-router-dom';
import { PROCUREMENTSUPPLIER } from '../../routes';

const ProcurementSupplierRoute = () => (
	<GameQuery>
		{({ game }) => (
			<Route
				path={PROCUREMENTSUPPLIER}
				render={props => <ProcurementSupplier {...props} game={game} />}
			/>
		)}
	</GameQuery>
);

export default ProcurementSupplierRoute;
